import {
  getLanguageKey,
  LocalesLanguagesConstants,
} from '../../../../locales/locales';
import { BaseBuyerService } from '../../base-buyer.service';
import { BuyerDocumentSaveRequestDto } from '../dto/request/buyer-document-save-request.dto';
import { BuyerDocumentUpdateRequestDto } from '../dto/request/buyer-document-update-request.dto';
import { BuyerDocumentResponseDto } from '../dto/response/buyer-document-response.dto';

class BuyerDocumentService extends BaseBuyerService {
  public async fetchDocumentById(
    id: string,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<BuyerDocumentResponseDto> {
    const response = await this.get<BuyerDocumentResponseDto>(
      `/document/${id}`,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async saveBuyerDocument(
    saveRequest: BuyerDocumentSaveRequestDto,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<BuyerDocumentResponseDto> {
    const response = await this.post<BuyerDocumentResponseDto>(
      `/document`,
      saveRequest,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async updateDocument(
    updateRequest: BuyerDocumentUpdateRequestDto,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<BuyerDocumentResponseDto> {
    const response = await this.put<BuyerDocumentResponseDto>(
      `/document`,
      updateRequest,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async deleteDocument(existingId: string): Promise<void> {
    await this.delete<void>(`/document/${existingId}`);
  }
}

const buyerDocumentService = new BuyerDocumentService();
export default buyerDocumentService;
